import {
    Component,
    Input,
    ChangeDetectionStrategy,
    input,
} from '@angular/core';
import ColorStop from '@arcgis/core/renderers/visualVariables/support/ColorStop';
import _ from 'lodash';

@Component({
    selector: 'app-map-color-gradient-legend',
    templateUrl: './map-color-gradient-legend.component.html',
    styleUrls: ['./map-color-gradient-legend.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MapColorGradientLegendComponent {
    @Input() set colorVariableStops(colorVariableStops: ColorStop[] | null) {
        if (colorVariableStops?.length) {
            this._colorVariableStops = colorVariableStops;

            this.highestStopValue = this._colorVariableStops!.sort(
                (a, b) => b.value - a.value,
            )[0].value;
            this.gradientCSS = this.generateCSSFromColorVariables(
                this._colorVariableStops!,
            );
        }
    }

    private _colorVariableStops: ColorStop[] = [];

    readonly label = input<string>();
    readonly minimumValueText = input<string>('Below Historical Average');
    readonly maximumValueText = input<string>('Above Historical Average');

    gradientCSS: string = '';
    highestStopValue: number = 0;

    generateCSSFromColorVariables(colorVariables: ColorStop[]) {
        const sortedColorVariableStops: ColorStop[] = colorVariables.sort(
            (a, b) => a.value - b.value,
        );

        const baseColorRgb = sortedColorVariableStops[0].color.toCss();
        let gradientCSS = `background: ${baseColorRgb};`;
        const maxValue =
            _.maxBy(sortedColorVariableStops, (x) => x.value)?.value ?? 0;
        gradientCSS += `background: linear-gradient(90deg,`;

        for (const colorVariableStop of sortedColorVariableStops) {
            const currentColorVariableStopRgb = colorVariableStop.color.toCss();
            const percentOfColor = (colorVariableStop.value / maxValue) * 100;
            gradientCSS += `${currentColorVariableStopRgb} ${percentOfColor}%`;

            if (
                sortedColorVariableStops.indexOf(colorVariableStop) <
                sortedColorVariableStops.length - 1
            ) {
                gradientCSS += `,`;
            }
        }

        gradientCSS += `);`;

        return gradientCSS;
    }
}
